import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mooc',
  templateUrl: './mooc.component.html',
  styleUrls: ['./mooc.component.scss']
})
export class MoocComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
